<script>
import * as Sentry from '@sentry/vue'
import CropImageV2 from '@/components/presentations/CropImage.v2.vue'

export default {
  extends: CropImageV2,
  methods: {
    onCropperReady() {
      if (!this.initialAspectRatio) return
      this.resetToInitialAspectRatio()
    },
    resetToInitialAspectRatio() {
      try {
        this.cropper.reset()
        this.cropper.setAspectRatio(this.initialAspectRatio)
        this.curRatio = this.initialAspectRatio
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
}
</script>
